import Message from '@admin/components/message'
import PropTypes from 'prop-types'
import React from 'react'

class Purchase extends React.PureComponent {

  static propTypes = {
    formdata: PropTypes.object,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  _handleNext = this._handleNext.bind(this)

  constructor(props) {
    super(props)
    this.state = {
      config: props.formdata || {}
    }
  }

  render() {
    return (
      <Message { ...this._getMessage() } />
    )
  }

  _getMessage() {
    return {
      svg: 'app_window',
      title: 't(Configure Your Website)',
      text: 't(Thank you for purchasing a website! To get started, please complete the Website Intake Form. This is the first step in your account setup and provides the personalized details we need to tailor your design. Your website will be built once your full setup is complete, including all required intake forms, branding preferences, and account configuration details.)',
      buttons: [
        {
          label: 't(Start Form)',
          handler: this._handleNext
        }
      ]
    }
  }

  _handleNext() {
    this.props.onNext({})
  }

}

export default Purchase
